module.exports = __webpack_public_path__ + "static/img/role0016.0b00639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role0016.jpg
// module id = plfo
// module chunks = 1